//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as axios from "@/store/http";

    export default {
        name: "ChangeLang",
      data(){
          return{
            options: [{
              value: 'zh',
              label: '中文'
            }, {
              value: 'en',
              label: 'English'
            }
            ],
            value: '',//语言选择下拉框当前语言文字描述
          }
      },
      methods:{
        async headChangeLang(value,label){
          this.changeLanguage(value) //调用公共切换语言方法
          this.value = label;
          //设置语言cookie
          //this.Setcookie("ZSMART_LOCALE",value);
          await axios.post("userController/changelanguage",{"language":value},{
          }).then((res)=>{
            console.log('2019年09月16日16:52:33 ChangeLang.vue[进入语言转换axios]——[null] :',null);
            console.log(res)
            location.reload()
          }).catch(function(error){
            console.log(error)//错误处理 相当于error
          })

          //this.changeLanguage(value) //调用公共切换语言方法
          this.value = label;
          //设置语言cookie
          //this.Setcookie("ZSMART_LOCALE",value);
          
        },
      },
      mounted(){
        // 初始化语言下拉框描述文字
        for(var i=0; i<this.options.length; i++){
          if(this.options[i].value === this.$i18n.locale){
            this.value = this.options[i].label
            break
          }
        }
      }
    }



// WEBPACK FOOTER //
// ./src/pccomponents/ChangeLang.vue